"use strict";

import {siteConfig} from '../siteConfig';
import { builderVersion } from '../version.json';

var angular = require("angular");

var dashboardIntegrationDirectiveCtrl = [
    "$scope","Authentication","toast","Upload","$translate","Integration","$uibModal","Form","$http","$timeout",
  function ($scope, Authentication, toast, Upload, $translate, Integration, $uibModal, Form, $http, $timeout) {
    var _this = this;

    _this.responseAPI = "";
    _this.Integration = Integration;
    _this.Authentication = Authentication;
    this.siteConfig = siteConfig;

    this.user = Authentication.currentUserInfo ? Authentication.currentUserInfo() : null;

    if (!this.integration || !this.integration.configuration || !this.integration.configuration.connection) {
      return;
    }

    if (!this.integration.configuration.connection.headers) {
      this.integration.configuration.connection.headers = {};
    }
    if (!this.integration.configuration.connection.refreshOffline)
      this.integration.configuration.connection.refreshOffline=8;
    
    if (_this.integration.departmentId != undefined && _this.departments.find((clt) => clt.id == _this.integration.departmentId) == undefined)
        _this.departments = [];

    _this.departmentforms = _this.departmentforms || [];
    _this.integration.configuration.connection.selectedForm = _this.integration.configuration.connection.selectedForm || { formId: '' };
    if (_this.integration.configuration.connection.validationState == null) {
        _this.integration.configuration.connection.validationState = "";
    }
    _this.integration.configuration.connection.urlGoogleRaw = _this.integration.configuration.connection.urlGoogleRaw || "";
            
    // For formUrl to select elements
    _this.listfields = [];
    _this.form = null;
    _this.returnDataItems = { fieldId: null, name: null };

    // Forms grouped by department for select-optgroup
    _this.flattenedForms = [];
    _this.departmentforms.forEach(function (department) {
        department.forms.forEach(function (form) {
            if (!form.id == '') { // if form.id == '' is not included
                _this.flattenedForms.push({
                    departmentName: department.name,
                    departmentId: form.departmentId,
                    formName: form.name,
                    formId: form.id,
                });
            }
        });
    });

    // TABS URL
    this.urlList = [
        { id: 'form', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.FORM")},
        { id: 'voolks_sheet', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.VOOLKS_SHEET")},
        { id: 's3', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.S3")}, // Big Tables
        { id: 'google', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.GOOGLE")},
        { id: 'standard', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.STANDARD")},
        { id: 'ai', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.AI")},
    ];

    // TABS VOOLKS SHEET getData
    this.tabVoolksSheetList = [
        { id: 'simple', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.VOOLKS_SHEET_MODE.SIMPLE")},
        { id: 'advanced', name: $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.VOOLKS_SHEET_MODE.ADVANCED")},
    ]

    this.sheet = {
        idGoogleSheet: null,
        sheetName: null,
    };
    this.listGoogleSheetNames = [];
    this.lastLoadedGoogleSheetId = null;

    this.voolksFiles = [];
    this.voolksCurrentSheets = [];

    this.OperationLabels = {
      "equal": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.EQUAL'), // =
      "diff": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.DISTINT'),// !=
      "lt": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.LESS'), // <
      "gt": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.GREATER'), // >
      "lte": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.LESS_EQUAL'), // <=
      "gte": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.GREATER_EQUAL'), // >=
      "starts": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.STARTS_WITH'), // starts with
      "ends": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.ENDS_WITH'), // ends with
      "contains": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.CONTAINS'), // contains
      "ignore": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.IGNORE') // ignore condition (for simple mode)
    };

    this.OperationKeys = ["equal", "diff", "lt", "gt", "lte", "gte", "starts", "ends", "contains", "ignore"];

    this.loadVoolksFiles = function () {
        const tenantId = (this.user && this.user?.tenantId) ? this.user?.tenantId : "";
        if (!tenantId) return;

        const SHEETS_API_BASE = this.siteConfig.sheetsApiBase;
        const url = SHEETS_API_BASE + "/files/integration/list";

        const headers = {
            'Authorization': 'Bearer ' + (Authentication.getAccessToken ? Authentication.getAccessToken() : ''),
            'systemId': 'builder',
            'systemVersion': builderVersion,
            'userId': _this.user ? _this.user.id : '',
        };
        
        $http.get(url, { headers: headers }).then(function (res) {
            _this.voolksFiles = Array.isArray(res.data) ? res.data : [];
            _this.updateVoolksSheetsList(); // in case value is already selected
            _this.onVoolksSheetSelected(); // in case sheet.columns needs to be loaded
        }).catch(function (err) {
            console.error("Error loading Voolks files", err);
            _this.voolksFiles = [];
        });
    };
  
    this.onVoolksFileSelected = function () {
        _this.integration.configuration.connection.sheet.sheetId = ''; // resetear hoja seleccionada al cambiar de libro
        _this.updateVoolksSheetsList();
    };

    this.updateVoolksSheetsList = function() {
        _this.voolksCurrentSheets = [];

        if (!_this.integration.configuration.connection.sheet.fileId) return;

        // El endpoint devuelve: [{ id, name, sheets: [{id, name}, ...] }]
        let selectedFile = _this.voolksFiles.find((f) => f.id === _this.integration.configuration.connection.sheet.fileId)

        if (!selectedFile || !Array.isArray(selectedFile.sheets)) {
          // Si no encontramos el libro, limpiamos hoja/selección.
          _this.voolksCurrentSheets = [];
          _this.integration.configuration.connection.sheet.sheetId = '';
          return;
        }

        // Si seleccionaron el libro por name, normalizamos a id para que el ng-model sea consistente.
        if ((_this.integration.configuration.connection.sheet.fileId !== selectedFile.id) && selectedFile.id) {
          _this.integration.configuration.connection.sheet.fileId = selectedFile.id;
        }

        _this.voolksCurrentSheets = selectedFile.sheets;

        if (!_this.integration.configuration.connection.sheet.sheetId) return;

        const selectedSheet =
          _this.voolksCurrentSheets.find((s) => s.id === _this.integration.configuration.connection.sheet.sheetId)

        if (!selectedSheet) {
          _this.integration.configuration.connection.sheet.sheetId = '';
          return;
        }

        // Normaliza sheetId a id si vino como name.
        if (_this.integration.configuration.connection.sheet.sheetId !== selectedSheet.id && selectedSheet.id) {
          _this.integration.configuration.connection.sheet.sheetId = selectedSheet.id;
        }
    };


    this.onVoolksSheetSelected = () => {
        _this.listfields = [];

        // tengo que guardar sheet.columns en una variable para mostrar en fieldId de voolks_sheets
        let selectedSheet = _this.voolksCurrentSheets.find((f) => f.id === _this.integration.configuration.connection.sheet.sheetId);

        if (selectedSheet && Array.isArray(selectedSheet.columns)) {
            _this.listfields = selectedSheet.columns.map((col) => ({
                id: col.split("|")[0], // guardo el id original en id para luego mapearlo al fieldId del dynamicParam
                name: col, // col.split("|")[1] ??
            }));
        }
    }

    this.canOpenSelectedVoolksFile = function () {
        return !!(_this.integration &&
            _this.integration.configuration &&
            _this.integration.configuration.connection &&
            _this.integration.configuration.connection.sheet &&
            _this.integration.configuration.connection.sheet.fileId);
    };

    this.openSelectedVoolksFile = function ($event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        if (!_this.canOpenSelectedVoolksFile()) {
            return;
        }

        const fileId = _this.integration.configuration.connection.sheet.fileId;
        const accessToken = Authentication.getAccessToken ? Authentication.getAccessToken() : "";
        const accountId = _this.user && _this.user.id ? _this.user.id : "";
        const sheetsFrontUrl = (_this.siteConfig && _this.siteConfig.sheetsFrontUrl) ? _this.siteConfig.sheetsFrontUrl : "";

        if (!sheetsFrontUrl) {
            return;
        }

        window.open(
            sheetsFrontUrl + "/" + fileId + "?" + new URLSearchParams({
                access_token: accessToken,
                accountId: accountId,
                firstName: (_this.user && _this.user.firstName) || "",
                lastName: (_this.user && _this.user.lastName) || "",
                email: (_this.user && _this.user.email) || "",
            }),
            "_blank"
        );
    };

    if (_this.integration.clientId != undefined && _this.integration.clientId != null &&
        _this.clients.find((clt) => clt.id == _this.integration.clientId) == undefined) {
        _this.clients = [];
    }
    //DEPT && SITE
    if (_this.integration.id == undefined && _this.departments.length > 0) {
        _this.integration.clientId = null;
        _this.integration.departmentId = null;
    }

    this.uploadFiles = function (file, errFile) {
      if (file) {
        _this.integration.configuration.connection.url =
          file.name + " " + $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.STANDARD.UPLOADING_FILE");
        let ext = file.name.slice(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        );
        let apiURL = require("../server").server;
        file.upload = Upload.upload({
          url: apiURL + "/containers/" + _this.integration.tenantId + "/upload",
          data: { file: file },
          picFile: Upload.rename(
            file,
            "integration-" + _this.integration.id.toString() + "." + ext
          ),
          success: function (res) {
            console.log(res);
          },
        });

        file.upload.then(function (response) {
          toast.success(
            $translate.instant("DASHBOARD.DASH_FORM.REPORT.LBL_LOGO_OK")
          );
          _this.integration.configuration.connection.url =
            apiURL +
            "/containers/" +
            response.data.result.files.file[0].container +
            "/download/" +
            response.data.result.files.file[0].name;
          console.log(response);
        });
      }
    };

    this.checkParams = function () {
      $uibModal.open({
        animation: true,
        template: `<div style="margin: 10px;padding: 10px;"><div class="row dashboard-section-title"><div class="col-sm-12"><h3 class="dashboard-section-title__h3">${$translate.instant("DASHBOARD.DASH_INTEG.FIELDS.EDITOR.PARAMS_TITLE")}</h3>
            <small>${$translate.instant("DASHBOARD.DASH_INTEG.FIELDS.EDITOR.SAVE_CHANGES_HINT")}</small></div>
                    <div class="col-sm-12"><textarea style="padding:10px;background-color: #fcf6db;color:#000;border: 1px solid #e5e0c6;height: 500px;width:100%;">{{ctrl.responseText}}</textarea></div>
                    <div class="row margin-top">
                        <div class="col-sm-12">                                            
                        </div>
                    </div>
                </div>`,
        controller: [
          "$uibModalInstance",
          "responseText",
          function ($uibModalInstance, responseText) {
            this.responseText = JSON.stringify(responseText, undefined, 4);
            this.close = function () {
              $uibModalInstance.close();
            };
          },
        ],
        resolve: {
          responseText: function () {
            return {
              ..._this.integration.configuration.connection.staticParams,
              ..._this.integration.configuration.connection.dynamicParams,
            };
          },
        },
        controllerAs: "ctrl",
        size: "lg",
        windowClass: "dialog",
        bindToController: true,
      });
    };

    this.checkApi = function (onlyWS) {
      let dynamicParams = _this.integration.configuration.connection.dynamicParams;
      if (_this.integration.configuration.connection.urlType == 'google' || _this.integration.configuration.connection.urlType == 'voolks_sheet') {
        // dynamicParams es un objeto de este tipo: dynamicParams: {hola: {value: "chau", fieldId: "A", operation: "equal"}} y se debe convertir a dynamicParams: {hola: "chau"} para google y voolks_sheets
        dynamicParams = Object.keys(dynamicParams).reduce((obj, key) => {
          obj[key] = dynamicParams[key].value;
          return obj;
        }, {});
      }
      _this.responseAPI = "";
      if (_this.integration.id) {
        //"body": "{\"params\":{\"cadena\":\"COTO\"}}\n",
        _this.Integration.request(
          { integrationId: _this.integration.id },
          {
            onlyWS: onlyWS,
            // params: _this.integration.configuration.connection.dynamicParams,
            params: dynamicParams,
            timestamp: new Date().getTime(), // para evitar cache en la respuesta
            returnErrorMessage: !onlyWS,
          }
        ).$promise.then((json) => {
          _this.responseAPI =
            json.response instanceof Object
              ? JSON.stringify(json.response, undefined, 4)
              : json.response;
          $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-integration/data-modal-success.html',
            controller: [
              "$uibModalInstance",
              "responseText",
              function ($uibModalInstance, responseText) {
                this.responseText = responseText;
                this.close = function () {
                  $uibModalInstance.close();
                };
              },
            ],
            resolve: {
              responseText: function () {
                return _this.responseAPI;
              },
            },
            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
          });
        });
      } else {
        _this.responseAPI = $translate.instant("DASHBOARD.DASH_INTEG.SAVE_FIRST");
        $uibModal.open({
          animation: true,
          templateUrl: 'dashboard-integration/data-modal-error.html',
          controller: [
            "$uibModalInstance",
            "responseText",
            function ($uibModalInstance, responseText) {
              this.responseText = responseText;
              this.close = function () {
                $uibModalInstance.close();
              };
            },
          ],
          resolve: {
            responseText: function () {
              return _this.responseAPI;
            },
          },
          controllerAs: "ctrl",
          size: "lg",
          windowClass: "dialog",
          bindToController: true,
        });
      }
    };

    this.checkVoolksSheetApi = function (onlyWS) {
      _this.responseAPI = "";
      if (_this.integration.id) {
        _this.Integration.request(
          { integrationId: _this.integration.id },
          {
            onlyWS: onlyWS,
            params: Object.keys(_this.integration.configuration.connection.dynamicParams).reduce((obj,key)=>{obj[key] = _this.integration.configuration.connection.dynamicParams[key].value; return obj},{}),
            timestamp: new Date().getTime(), // para evitar cache en la respuesta
            returnErrorMessage: !onlyWS,
          }
          ).$promise.then((json) => {
          _this.responseAPI =
            json.response instanceof Object
              ? JSON.stringify(json.response, undefined, 4)
              : json.response;
          $uibModal.open({
            animation: true,
            templateUrl: "dashboard-integration/data-modal-success.html",
            controller: [
              "$uibModalInstance",
              "responseText",
              function ($uibModalInstance, responseText) {
                this.responseText = responseText;
                this.close = function () {
                  $uibModalInstance.close();
                };
              },
            ],
            resolve: {
              responseText: function () {
                return _this.responseAPI;
              },
            },
            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
          });
        })
        .catch(function (err) {
            console.error("Error", err);
        });
    } else {
        _this.responseAPI = $translate.instant("DASHBOARD.DASH_INTEG.SAVE_FIRST");
        $uibModal.open({
          animation: true,
          templateUrl: "dashboard-integration/data-modal-error.html",
          controller: [
            "$uibModalInstance",
            "responseText",
            function ($uibModalInstance, responseText) {
              this.responseText = responseText;
              this.close = function () {
                $uibModalInstance.close();
              };
            },
          ],
          resolve: {
            responseText: function () {
              return _this.responseAPI;
            },
          },
          controllerAs: "ctrl",
          size: "lg",
          windowClass: "dialog",
          bindToController: true,
        });
      }
    };

    this.changeType = function (integration) {
      if (integration.configuration.connection.urlType === 'ai' && integration.type !== 'populate') {
        integration.type = 'populate';
        return;
      }
      // Voolks Sheet || Google Sheets - getData || populate
      if ((_this.integration.configuration.connection.urlType == 'voolks_sheet' || _this.integration.configuration.connection.urlType == 'google') &&
        (_this.integration.type === 'getData' || _this.integration.type === 'populate')
      ) {
            _this.integration.configuration.afterHookType = 'simple';
            _this.initReturnData(_this.integration.configuration);
      }

      if (integration.type === "populate") {
        integration.configuration.populateValues = integration.configuration
          .populateValues
          ? integration.configuration.populateValues
          : {};
        return;
      }

      if (integration.configuration.populateValues) {
        integration.configuration.populateValues = {};
      }

      return;
    };

    this.isKeyValidForSelect = function (dynamicParams) {
        const regex = /^\{[A-Za-z0-9_]+\}$/;
        return (
            regex.test(dynamicParams?.key) &&
            _this.integration.configuration.connection?.urlType === 'form' &&
            !!_this.integration.configuration.connection?.selectedForm?.formId
        );
    };

     this.addValuePopulate = function (values, where) {
      if (!values) {
        return;
      }

      if (values && !values.key) {
        return;
      }
      values.key = values.key.replace(/\s/g, "-");

      if (!where) {
        where = {};
      }
      if (where.hasOwnProperty(values.key)) {
        values.key = null;
        values.value = null;
        return;
      }

      where[values.key] = values.value ? values.value : "";
      values.key = null;
      values.value = null;
      return;
    };

    this.aiPopulateDraft = { key: null, defaultValue: null, description: null, type: 'text' };

    this.addValuePopulateAi = function (values, where) {
      if (!values || !values.key || !where || Array.isArray(where)) {
        return;
      }

      values.key = values.key.replace(/\s/g, "-");

      if (where.hasOwnProperty(values.key)) {
        values.key = null;
        values.defaultValue = null;
        values.description = null;
        values.type = 'text';
        return;
      }

      where[values.key] = {
        defaultValue: values.defaultValue ? values.defaultValue : "",
        type: values.type === 'number' ? 'number' : 'text',
        description: values.description ? values.description : "",
      };
      values.key = null;
      values.defaultValue = null;
      values.description = null;
      values.type = 'text';
    };

    this.addValue = function (values, where) {
        if (!values || !values.key) {
            return;
        }

        values.key = values.key.replace(/\s/g, "-");

        if (!where) where = {};

        if (where.hasOwnProperty(values.key)) {
            values.key = null;
            values.value = null;
            values.fieldId = null;
            return;
        }
        if (where.hasOwnProperty(values.operation)) {
            values.operation = null;
        }

        // standard
        if (_this.integration.configuration.connection.urlType === "standard" ||
            _this.integration.configuration.connection.urlType === "s3" ||
            _this.integration.configuration.connection.urlType === "ai"
        ) {
            where[values.key] = values.value ? values.value : "";
        }

        // form
        else if (_this.integration.configuration.connection.urlType === "form") {
            const regex = /^\{[A-Za-z0-9_]+\}$/;
            if (regex.test(values.key)) {
            // Save object (value + fieldId)
            where[values.key] = {
                value: values.value ? values.value : "",
                fieldId: values.fieldId ? values.fieldId : null,
            };
            } else {
            // Save only value
            where[values.key] = values.value ? values.value : "";
            }
        } 
        else if (_this.integration.configuration.connection.urlType === "voolks_sheet" ||
            _this.integration.configuration.connection.urlType === "google"
        ) {
            where[values.key] = {
                value: values.value ? values.value : "",
                fieldId: values.fieldId ? values.fieldId : null,
                operation: values.operation ? values.operation : null,
            };
        }

        // Reset
        values.key = null;
        values.value = null;
        values.fieldId = null;
        values.operation = null;
    };

    this.removeValue = function (key, where) {
      delete where[key];
    };

    this.addValueS3 = function (column, where) {
        if (!column || !column.name) {
            return;
        }   

        column.name = column.name.replace(/\s/g, "_");
        column.type = column.type ? column.type : "text";
        // column.pk = column.pk ? true : false;
        column.index = column.index ? true : false;

        if (!_this.integration.configuration.connection.s3) {
            _this.integration.configuration.connection.s3 = {
                tableName: null,
                columns: []
            };
        }
        
        if (!_this.integration.configuration.connection.s3.columns) {
            _this.integration.configuration.connection.s3.columns = [];
        }

        if (_this.integration.configuration.connection.s3.columns.find((col) => col.name == column.name)) {
            toast.error($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.S3.COLUMN_ALREADY_EXISTS"));
            return;
        }

        _this.integration.configuration.connection.s3.columns.push({
            name: column.name,
            type: column.type,
            // pk: column.pk,
            pk: false,
            index: column.index,
        });

        _this.s3ColumnValues = {
            name: null,
            type: "TEXT",
            // pk: false,
            index: false,
        };
        return;
    }

    this.removeValueS3 = function (index, where) {
      where.splice(index, 1);
    }

    this.addItem =(item, where) => {
        if (!item || !item.fieldId) {
            return;
        }
        
        if (!item.name || !String(item.name).trim()) {
            // voolks_sheet || google sheet - getData Simple
            if (_this.integration.type === 'getData' && _this.integration.configuration.afterHookType == 'simple') {
                // name is not required in simple mode, set ''.
                item.name = '';
            // voolks_sheet || google sheet - populate
            } else if (_this.integration.type === 'populate' && 
                (_this.integration.configuration.connection.urlType === 'voolks_sheet' || _this.integration.configuration.connection.urlType === 'google'))
            {
                toast.error($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.PARAM_NAME_REQUIRED"));
                item.name = String(item.name).trim();
                return;
            }
        }

        where.push(angular.extend({}, item));
        item.fieldId = null;
        item.name = null;
    }

    this.removeItem =(index, where) => {
        where.splice(index, 1);
    }


    this.updatePK = function(index) {
        _this.integration.configuration.connection.s3.columns.forEach(function(col, i) {
            col.pk = (i === index);
        });
    };
    this.selectedPK = null;

    _this.loadEditorHTML = function () {
      _this.editor = ace.edit("afterHookEditor");
      _this.editor.setOptions({
        // editor options
        selectionStyle: "line", // "line"|"text"
        highlightActiveLine: true, // boolean
        highlightSelectedWord: true, // boolean
        readOnly: false, // boolean: true if read only
        cursorStyle: "ace", // "ace"|"slim"|"smooth"|"wide"
        mergeUndoDeltas: true, // false|true|"always"
        behavioursEnabled: true, // boolean: true if enable custom behaviours
        wrapBehavioursEnabled: true, // boolean
        autoScrollEditorIntoView: undefined, // boolean: this is needed if editor is inside scrollable page
        keyboardHandler: null, // function: handle custom keyboard events

        // renderer options
        animatedScroll: false, // boolean: true if scroll should be animated
        displayIndentGuides: false, // boolean: true if the indent should be shown. See 'showInvisibles'
        showInvisibles: false, // boolean -> displayIndentGuides: true if show the invisible tabs/spaces in indents
        showPrintMargin: true, // boolean: true if show the vertical print margin
        printMarginColumn: 80, // number: number of columns for vertical print margin
        printMargin: undefined, // boolean | number: showPrintMargin | printMarginColumn
        showGutter: true, // boolean: true if show line gutter
        fadeFoldWidgets: false, // boolean: true if the fold lines should be faded
        showFoldWidgets: true, // boolean: true if the fold lines should be shown ?
        showLineNumbers: true,
        highlightGutterLine: false, // boolean: true if the gutter line should be highlighted
        hScrollBarAlwaysVisible: false, // boolean: true if the horizontal scroll bar should be shown regardless
        vScrollBarAlwaysVisible: false, // boolean: true if the vertical scroll bar should be shown regardless
        fontSize: 14, // number | string: set the font size to this many pixels
        fontFamily: undefined, // string: set the font-family css value
        maxLines: undefined, // number: set the maximum lines possible. This will make the editor height changes
        minLines: undefined, // number: set the minimum lines possible. This will make the editor height changes
        maxPixelHeight: 0, // number -> maxLines: set the maximum height in pixel, when 'maxLines' is defined.
        scrollPastEnd: 0, // number -> !maxLines: if positive, user can scroll pass the last line and go n * editorHeight more distance
        fixedWidthGutter: false, // boolean: true if the gutter should be fixed width
        theme: "ace/theme/dracula", // theme string from ace/theme or custom?

        // mouseHandler options
        scrollSpeed: 2, // number: the scroll speed index
        dragDelay: 0, // number: the drag delay before drag starts. it's 150ms for mac by default
        dragEnabled: true, // boolean: enable dragging
        focusTimeout: 0, // number: the focus delay before focus starts.
        tooltipFollowsMouse: true, // boolean: true if the gutter tooltip should follow mouse

        // session options
        firstLineNumber: 1, // number: the line number in first line
        overwrite: false, // boolean
        newLineMode: "auto", // "auto" | "unix" | "windows"
        useWorker: true, // boolean: true if use web worker for loading scripts
        useSoftTabs: true, // boolean: true if we want to use spaces than tabs
        tabSize: 4, // number
        wrap: false, // boolean | string | number: true/'free' means wrap instead of horizontal scroll, false/'off' means horizontal scroll instead of wrap, and number means number of column before wrap. -1 means wrap at print margin
        indentedSoftWrap: true, // boolean
        foldStyle: "markbegin", // enum: 'manual'/'markbegin'/'markbeginend'.
        mode: "ace/mode/javascript", // string: path to language mode
      });
      _this.editor.session.on("change", function (delta) {
        _this.integration.configuration.afterHook =
          _this.editor.session.getValue();
      });
    };

    _this.formatCode = () => {
      _this.editor.session.setValue(
        js_beautify(_this.editor.session.getValue())
      );
    };

    this.openExampleModal = function () {
        $uibModal.open({
            animation: true,
            templateUrl: "dashboard-integration/dashboardIntegrationExampleModal.html",
            controller: ["$uibModalInstance", "siteConfig",
                function ($uibModalInstance, siteConfig) {
                    this.siteConfig = siteConfig;

                    this.close = function () {
                        $uibModalInstance.close();
                    };
                }
            ],
            controllerAs: "modal",
            size: "xlg",
            resolve: {
                siteConfig: function () {
                    return _this.siteConfig;
                }
            },
            windowClass: "dialog",
            bindToController: true
        });
    };

    // MODAL ASISTENTE GOOGLE SHEET
    this.openGoogleSheetAssistantModal = function () {
        const modalInstance = $uibModal.open({
            animation: true,
            templateUrl: "dashboard-integration/dashboardIntegrationGoogleSheetAssistantModal.html",
            controller: ["$uibModalInstance", "initialUrlGoogleRaw", "initialAuthTypeSelection",
                function ($uibModalInstance, initialUrlGoogleRaw, initialAuthTypeSelection) {
                    this.url = initialUrlGoogleRaw ? String(initialUrlGoogleRaw) : "";
                    this.authTypeSelection = initialAuthTypeSelection || "";

                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };

                    this.getParams = function () {
                        const url = (this.url || "").trim();

                        if (!url) {
                            return;
                        }

                        const idGoogleSheetMatch = url.match(/\/spreadsheets\/(?:d\/)?([a-zA-Z0-9-_]+)/);
                        let sheetName = "";
                        const valuesMatch = url.match(/\/values\/([^/?#]+)/);

                        if (valuesMatch && valuesMatch[1]) {
                            sheetName = decodeURIComponent(valuesMatch[1]);
                        }

                        if (!idGoogleSheetMatch || !idGoogleSheetMatch[1]) {
                            toast.error($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ID_PARSE_ERROR"));
                            return;
                        }

                        $uibModalInstance.close({
                            idGoogleSheet: idGoogleSheetMatch ? idGoogleSheetMatch[1] : "",
                            sheetName: sheetName,
                            urlGoogleRaw: url,
                            hasAuthTypeSelection: this.authTypeSelection !== null,
                            authType: this.authTypeSelection
                        });
                    };
                }
            ],
            controllerAs: "modal",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                initialUrlGoogleRaw: function () {
                    return _this.integration.configuration.connection.urlGoogleRaw || "";
                },
                initialAuthTypeSelection: function () {
                    return _this.integration.configuration.auth?.type || "";
                }
            }
        });

        modalInstance.result.then(function (result) {
            if (result.urlGoogleRaw) {
                _this.integration.configuration.connection.urlGoogleRaw = result.urlGoogleRaw;
            }

            if (result.idGoogleSheet) {
                _this.sheet.idGoogleSheet = result.idGoogleSheet;
            }

            if (result.sheetName) {
                _this.sheet.sheetName = result.sheetName;
            }
            if (result.hasAuthTypeSelection) {
                _this.integration.configuration.auth = _this.integration.configuration.auth || {};
                _this.integration.configuration.auth.type = result.authType;
            }

            _this.updateSheetUrl();
            _this.loadGoogleSheetData();
            if (result.sheetName) {
                _this.loadGoogleSheetColumns();
            }
        });
    };

    this.openGoogleSheetNamesModal = function () {
        if (!_this.canOpenGoogleSheetNamesModal()) {
            toast.error($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.LOAD_SHEETS_FIRST"));
            return;
        }

        const modalInstance = $uibModal.open({
            animation: true,
            templateUrl: "dashboard-integration/dashboardIntegrationGoogleSheetNamesModal.html",
            controller: ["$uibModalInstance", "sheetNames", "selectedSheetName",
                function ($uibModalInstance, sheetNames, selectedSheetName) {
                    this.sheetNames = sheetNames;
                    this.selectedSheetName = selectedSheetName || "";

                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };

                    this.accept = function () {
                        if (!this.selectedSheetName) {
                            return;
                        }
                        $uibModalInstance.close(this.selectedSheetName);
                    };
                }
            ],
            controllerAs: "modal",
            size: "md",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                sheetNames: function () {
                    return _this.listGoogleSheetNames;
                },
                selectedSheetName: function () {
                    return _this.sheet.sheetName;
                }
            }
        });

        modalInstance.result.then(function (sheetName) {
            if (!sheetName) {
                return;
            }
            _this.sheet.sheetName = sheetName;
            _this.updateSheetUrl();
            _this.loadGoogleSheetColumns();
        });
    };

    this.canOpenGoogleSheetNamesModal = function () {
        const hasLoadedList = Array.isArray(_this.listGoogleSheetNames) && _this.listGoogleSheetNames.length > 0;
        const hasCurrentId = !!_this.sheet.idGoogleSheet;
        return hasLoadedList && hasCurrentId && _this.lastLoadedGoogleSheetId === _this.sheet.idGoogleSheet;
    };

    this.canLoadGoogleColumns = function () {
        return !!(_this.sheet.idGoogleSheet && _this.sheet.sheetName);
    };

    this.openS3Modal = function () {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-integration/dashboardIntegrationS3Modal.html',
            controller: ["$uibModalInstance",
                function ($uibModalInstance) {                   
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                }],
            controllerAs: 'modal',
            size: 'lg',
            resolve: {},
            windowClass: 'dialog',
            bindToController: true,
        });
    };

    _this.syncPopulateAutocompleteByAfterHookMode = () => {
        const configuration = _this.integration.configuration;

        if (!((configuration.connection.urlType === 'voolks_sheet' || configuration.connection.urlType === 'google')
            && _this.integration.type === 'populate')) {
            return;
        }

        _this.initReturnData(configuration);

        if (configuration.afterHookType === 'advanced') {
            let hasSimpleFields = false;
            configuration.populateValues = configuration.populateValues && typeof configuration.populateValues === 'object'
                ? configuration.populateValues
                : {};

            for (const field of configuration.returnData.fields) {
                if (field && field.name && field.name !== "") {
                    configuration.populateValues[field.name] = field.fieldId ? field.fieldId : "";
                    hasSimpleFields = true;
                }
            }

            if (hasSimpleFields) {
                configuration.returnData.fields = [];
            }
        } else if (configuration.afterHookType === 'simple') {
            const convertedFields = [];

            if (configuration.populateValues && typeof configuration.populateValues === 'object') {
                for (const key of Object.keys(configuration.populateValues)) {
                    if (key && key !== "") {
                        const value = configuration.populateValues[key];
                        const normalizedValue = value && typeof value === 'object' && value.hasOwnProperty('value')
                            ? value.value
                            : value;

                        convertedFields.push({
                            name: key,
                            fieldId: normalizedValue ? normalizedValue : null,
                        });
                    }
                }
            }

            if (convertedFields.length > 0) {
                configuration.returnData.fields = convertedFields;
                configuration.populateValues = {};
            }
        }
    }

    // VOOLKS SHEET || GOOGLE SHEET - getData - Simple/Advanced
    _this.selectVoolksSheetAfterHookTab = (id) => {
        _this.integration.configuration.afterHookType = id;

        if (id === 'simple') {
            _this.initReturnData(_this.integration.configuration);
            _this.syncPopulateAutocompleteByAfterHookMode();
        } else if (id === 'advanced') {
            _this.syncPopulateAutocompleteByAfterHookMode();
            angular.element(document).ready(_this.loadEditorHTML);
        }
    }

    this.initReturnData = (configuration) => {
      if (!configuration.returnData || typeof configuration.returnData !== "object") {
        let simpleList = false;

        // Para getData voolks_sheet || google, isSimpleList es true porque solo se devuelve lista de objetos
        if (_this.integration.type === 'getData') {
            simpleList = true;
            configuration.sorted = false;
        }
        configuration.returnData = {
          fields: [],
          isTitleFirstValue: false,
          isSimpleList: simpleList,
        };
        return;
      }
      if (!Array.isArray(configuration.returnData.fields)) {
        configuration.returnData.fields = [];
      }
    }

    _this.applySelectUrlTab = (id, init = false) => {
        if (!init) {
            // Resetear campos específicos de cada tipo al cambiar de tab para evitar inconsistencias en la configuración
            _this.integration.configuration = {
                auth: {
                    type: "",
                },
                populateValues: { },
                type: 'json',
                typeRequest: 'data',
                connection: {
                    urlType: id, // Asigno el tab seleccionado
                    method: 'GET',
                    url: null,
                    staticParams: {},
                    dynamicParams: {},
                    headers: {},
                    data: null
                },
                afterHook: null
            }

            // Reset other variables used in specific integrations
            _this.listfields = [];
            _this.returnDataItems = { fieldId: null, name: null };
            this.sheet = {
                idGoogleSheet: null,
                sheetName: null,
            };
            this.listGoogleSheetNames = [];
            this.lastLoadedGoogleSheetId = null;

            this.voolksFiles = [];
            this.voolksCurrentSheets = [];

        } else {
            _this.integration.configuration.connection.urlType = id;
        }


        if (id !== "voolks_sheet" && id !== "google") {
            angular.element(document).ready(_this.loadEditorHTML);
        }
      
        if (id == "google") {
            // INIT
            if (init) {
                const url = _this.integration.configuration.connection.url;
                // https://sheets.googleapis.com/v4/spreadsheets/1VRdZeWZl4P1MitO4b0zlsrLejxsi2Vw_3HCCQ454FXw/values/Cadenas/
                
                if (url && url !== '') {
                    const matches = url.match(/spreadsheets\/([^\/]+)\/values\/([^\/]+)/);
                    _this.sheet.idGoogleSheet = matches ? matches[1] : '';
                    _this.sheet.sheetName = matches ? matches[2] : '';
                }

                if (_this.sheet.idGoogleSheet && _this.sheet.sheetName) {
                    _this.updateSheetUrl();
                    _this.loadGoogleSheetData();
                    _this.loadGoogleSheetColumns();
                }
            } else {
                _this.updateSheetUrl();
            }
                
            // Inicializo returnData para Google Sheets - getData Simple/Advanced
            if (_this.integration.type === 'getData' || _this.integration.type === 'populate') {
                if (!_this.integration.configuration.hasOwnProperty('afterHookType')) {
                    const isEditPageLoad = init && _this.integration.id != null;
                    _this.integration.configuration.afterHookType = isEditPageLoad ? 'advanced' : 'simple';
                    if (isEditPageLoad) {
                        _this.syncPopulateAutocompleteByAfterHookMode();
                    }
                }
                if (_this.integration.configuration.afterHookType === 'simple') {
                    _this.initReturnData(_this.integration.configuration);
                }
            }
        }
        else if (id == "voolks_sheet") {
            if(_this.voolksFiles.length === 0 || init) {
                _this.loadVoolksFiles();
            }
            if (!init || !_this.integration.configuration.connection.hasOwnProperty('sheet') || !_this.integration.configuration.connection.sheet.hasOwnProperty('fileId')) {
                _this.voolksCurrentSheets = [];
                this.integration.configuration.connection.sheet = {
                    fileId: '',
                    sheetId: ''
                };
                _this.integration.configuration.type = 'array';            }
            if (_this.integration.type === 'getData' || _this.integration.type === 'populate') {
                if (!_this.integration.configuration.hasOwnProperty('afterHookType')) {
                    const isEditPageLoad = init && _this.integration.id != null;
                    _this.integration.configuration.afterHookType = isEditPageLoad ? 'advanced' : 'simple';
                    if (isEditPageLoad) {
                        _this.syncPopulateAutocompleteByAfterHookMode();
                    }
                }
                if (_this.integration.configuration.afterHookType === 'simple') {
                    _this.initReturnData(_this.integration.configuration);
                }
            }
        }
        else if (id == "form") {
            if (!init) {
                _this.integration.configuration.connection.rows = null;
                _this.integration.configuration.connection.minDate = null;
                _this.integration.configuration.connection.maxDate = null;
                _this.integration.configuration.connection.validationState = "";
                _this.integration.configuration.connection.validationFrom = null;
                _this.integration.configuration.connection.validationUntil = null;
            }
            _this.updateFormUrl()
        }
        else if (id == 'ai') {
            _this.integration.configuration.type = 'json';
            _this.integration.configuration.typeRequest = 'json';
            _this.integration.configuration.connection.allowOffline = false;
            _this.integration.configuration.connection.method = 'POST';
            _this.integration.configuration.connection.url = '{ai-voolks-multimodal}';
            _this.integration.configuration.auth.type = 'AI';
            _this.ensureAiConnectionFields(_this.integration.configuration.connection);
        }
        else if (id == 's3') {
            if (!_this.integration.configuration.connection.s3) {
                _this.integration.configuration.connection.s3 = {
                    tableName: null,
                    source_type: 'text',
                    separator: '|',
                    output_type: 'sqlite',
                    columns: [],
                }
                this.s3ColumnValues = {
                    name: null,
                    type: 'TEXT',
                    // pk: false,
                    index: false,
                }
                this.selectedPL = null;
            }
        }
        
        // Convert dynamicParams according to tab change
        let dp = _this.integration.configuration.connection.dynamicParams || {};
        let newDp = {};

        if (id === "form") {
            Object.entries(dp).forEach(([key, val]) => {
                if (val && typeof val === "object" && val.hasOwnProperty("value")) {
                    // already in object format → leave it as is
                    newDp[key] = val;
                } else if (/^\{.*\}$/.test(key)) {
                    // key with {} but plain → convert to object
                    newDp[key] = { value: val, fieldId: null };
                } else {
                    // normal → leave as is
                    newDp[key] = val;
                }
            });
            _this.integration.configuration.connection.dynamicParams = newDp;
        }
        else if (id === "voolks_sheet" || id === "google") {
            Object.entries(dp).forEach(([key, val]) => {
                if (val && typeof val === "object" && val.hasOwnProperty("value")) {
                    // already in object format → leave it as is
                    newDp[key] = val;
                } else if (/^\{.*\}$/.test(key)) {
                    // key with {} but plain → convert to object
                    newDp[key] = { value: val, fieldId: null, operation: null };
                } else {
                    // normal → leave as is
                    newDp[key] = val;
                }
            });
            _this.integration.configuration.connection.dynamicParams = newDp;
        }
        else if (id === "standard" || id === "s3" || id === "ai") {
            Object.entries(dp).forEach(([key, val]) => {
                if (/^\{.*\}$/.test(key) && val && typeof val === "object" && val.hasOwnProperty("value")) {
                    // keep the {} in the key, but discard fieldId
                    newDp[key] = val.value;
                } else {
                    newDp[key] = val;
                }
            });
            _this.integration.configuration.connection.dynamicParams = newDp;
        }

        _this.integration.configuration.populateValues = _this.populateValuesForTab(
            id,
            _this.integration.configuration.populateValues
        );
    };

    _this.ensureAiConnectionFields = (connection) => {
        if (!connection) {
            return;
        }
        if (typeof connection.aiPrompt !== 'string') {
            connection.aiPrompt = typeof connection.prompt === 'string' ? connection.prompt : '';
        }
        delete connection.prompt;
        connection.aiPrompt = connection.aiPrompt.slice(0, 1024);
        if (connection.aiModel !== 'lite' && connection.aiModel !== 'pro') {
            connection.aiModel = 'lite';
        }
    };

    _this.populateValuesForTab = (id, populateValues) => {
        const toAiValue = (val) => {
            if (val && typeof val === 'object') {
                return {
                    defaultValue: val.defaultValue != null ? val.defaultValue : '',
                    type: val.type === 'number' ? 'number' : 'text',
                    description: val.description != null ? val.description : '',
                };
            }
            return {
                defaultValue: val != null ? val : '',
                type: 'text',
                description: '',
            };
        };

        if (id === 'ai') {
            const map = {};
            if (Array.isArray(populateValues)) {
                populateValues.forEach(function (item) {
                    if (item && item.key) {
                        map[item.key] = toAiValue(item);
                    }
                });
                return map;
            }
            Object.entries(populateValues || {}).forEach(function ([key, val]) {
                map[key] = toAiValue(val);
            });
            return map;
        }

        if (Array.isArray(populateValues)) {
            return populateValues.reduce(function (map, item) {
                if (item && item.key) {
                    map[item.key] = item.defaultValue != null ? item.defaultValue : '';
                }
                return map;
            }, {});
        }

        const map = {};
        Object.entries(populateValues || {}).forEach(function ([key, val]) {
            if (val && typeof val === 'object' && Object.prototype.hasOwnProperty.call(val, 'defaultValue')) {
                map[key] = val.defaultValue != null ? val.defaultValue : '';
            } else {
                map[key] = val;
            }
        });
        return map;
    };

    _this.selectUrlTab = (id, init = false) => {
        if (!init && id === 'ai' && _this.integration.type !== 'populate') {
            return;
        }
        if (init) {
            _this.applySelectUrlTab(id, true);
            return;
        }
        const conn = _this.integration.configuration && _this.integration.configuration.connection;
        const currentType = conn && conn.urlType;
        if (id === currentType) {
            return;
        }
        if (currentType == null || currentType === "") {
            _this.applySelectUrlTab(id, false);
            return;
        }
        $uibModal.open({
            animation: true,
            templateUrl: "dashboard-integration/dashboardIntegrationUrlTabChangeConfirmModal.html",
            controller: [
                "$uibModalInstance",
                function ($uibModalInstance) {
                    this.confirm = function () {
                        $uibModalInstance.close(true);
                    };
                    this.dismiss = function () {
                        $uibModalInstance.dismiss("cancel");
                    };
                },
            ],
            controllerAs: "modal",
            bindToController: true,
            size: "md",
            windowClass: "dialog",
        }).result.then(
            function () {
                _this.applySelectUrlTab(id, false);
            },
            angular.noop
        );
    };

    // Watch para rows for Form
    $scope.$watch(
        () => _this.integration.configuration.connection.rows,
        (newVal) => {
            if (_this.integration.configuration.connection.urlType == "form") {
                _this.updateFormUrl();
            }
        }
    );
    // Watch para minDate for Form
    $scope.$watch(
        () => _this.integration.configuration.connection.minDate,
        (newVal) => {
            if (newVal && !(newVal instanceof Date)) {
                _this.integration.configuration.connection.minDate = new Date(newVal);
            }
            if (!newVal) {
                _this.integration.configuration.connection.minDate = null;
            }
            if (_this.integration.configuration.connection.urlType == "form") {
                _this.updateFormUrl();
            }
        }
    );

    // Watch para maxDate for Form
    $scope.$watch(
        () => _this.integration.configuration.connection.maxDate,
        (newVal) => {
            if (newVal && !(newVal instanceof Date)) {
                _this.integration.configuration.connection.maxDate = new Date(newVal);
            }
            if (!newVal) {
                _this.integration.configuration.connection.maxDate = null;
            }
            if (_this.integration.configuration.connection.urlType == "form") {
                _this.updateFormUrl();
            }
        }
    );

    $scope.$watch(
        () => _this.integration.configuration.connection.validationFrom,
        (newVal) => {
            if (newVal && !(newVal instanceof Date)) {
                _this.integration.configuration.connection.validationFrom = new Date(newVal);
            }
            if (!newVal) {
                _this.integration.configuration.connection.validationFrom = null;
            }
            if (_this.integration.configuration.connection.urlType == "form") {
                _this.updateFormUrl();
            }
        }
    );

    $scope.$watch(
        () => _this.integration.configuration.connection.validationUntil,
        (newVal) => {
            if (newVal && !(newVal instanceof Date)) {
                _this.integration.configuration.connection.validationUntil = new Date(newVal);
            }
            if (!newVal) {
                _this.integration.configuration.connection.validationUntil = null;
            }
            if (_this.integration.configuration.connection.urlType == "form") {
                _this.updateFormUrl();
            }
        }
    );

    $scope.$watch(
        () => _this.integration.configuration.connection.validationState,
        () => {
            if (_this.integration.configuration.connection.urlType == "form") {
                _this.updateFormUrl();
            }
        }
    );

    // Watch para dynamicParams for Form
    $scope.$watch(
        () => _this.integration.configuration.connection.dynamicParams,
        (newVal, oldVal) => {
            if (newVal !== oldVal) {
                if (_this.integration.configuration.connection.urlType == "form") {
                    _this.updateFormUrl();
                }
            }
        },
        true // deep watch because it's an object
    );

    _this.updateSheetUrl = () => {
        const id = _this.sheet.idGoogleSheet;
        const name = _this.sheet.sheetName;
        const sheetUrl = 'https://sheets.googleapis.com/v4/spreadsheets/' + id + '/values/' + name + '/';
        this.integration.configuration.connection.url = sheetUrl;
        if (_this.lastLoadedGoogleSheetId !== id) {
            _this.listGoogleSheetNames = [];
            _this.lastLoadedGoogleSheetId = null;
        }
    };

    // OBTENER NOMBRES DE HOJAS DE GOOGLE SHEET
    _this.loadGoogleSheetData = () => {
        _this.updateSheetUrl();

        const integration = angular.copy(_this.integration);
        delete integration.configuration.connection.urlGoogleRaw;

        const payload = {
            integration: integration,
            config: {
                onlyWS: true,
                params: {},
                onlyColumns: true,
                onlySheets: true,
                timestamp: new Date().getTime(),
            }
        };
        _this.Integration.request2({}, payload).$promise
            .then(function (json) {
                const data = json && json.response ? json.response : json;
                
                if (data && data.length === 0) {
                    toast.error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'));
                    _this.listGoogleSheetNames = [];
                    _this.lastLoadedGoogleSheetId = null;

                    // Reset Columns
                    _this.listfields = [];
                    return;
                }

                if (Array.isArray(data)) {
                    _this.listGoogleSheetNames = data;
                    _this.lastLoadedGoogleSheetId = _this.sheet.idGoogleSheet;
                    toast.success($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.SHEETS_LOADED"));
                    return;
                }

                // Si llega aca es porque no es un array, lo cual es inesperado, por lo que se maneja como error
                throw new Error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'));
                
            })
            .catch(function (err) {
                toast.error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'));
                console.error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'), err);
                _this.listGoogleSheetNames = [];
                _this.lastLoadedGoogleSheetId = null;

                // Reset Columns
                _this.listfields = [];
            });
    };

    // OBTENER COLUMNAS DE GOOGLE SHEET
    _this.loadGoogleSheetColumns = () => {
        if (!_this.canLoadGoogleColumns()) {
            return;
        }

        _this.updateSheetUrl();
        const payload = {
            integration: angular.copy(_this.integration),
            config: {
                onlyWS: true,
                params: {},
                onlyColumns: true,
                onlySheets: false,
                timestamp: new Date().getTime(),
            }
        };

        _this.Integration.request2({}, payload).$promise
            .then(function (json) {
                const data = json && json.response ? json.response : json;

                if (data && data.length === 0) {
                    toast.error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'));
                    _this.listfields = [];
                    return;
                }

                if (!Array.isArray(data)) {
                    throw new Error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'));
                }

                const columns = data;

                _this.listfields = columns.map(function (columnName) {
                    const normalized = String(columnName || "");
                    const separatorIndex = normalized.indexOf("|");
                    const fieldId = separatorIndex >= 0
                        ? normalized.substring(0, separatorIndex)
                        : normalized;
                    return {
                        id: fieldId,
                        name: normalized,
                    };
                });
                toast.success($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.COLUMNS_LOADED"));
            })
            .catch(function (err) {
                toast.error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'));
                console.error($translate.instant('DASHBOARD.DASH_INTEG.FIELDS.GOOGLE.ERROR'), err);
                _this.listfields = [];
            });
    };

    _this.excludedFieldTypesForDynamicParams = ["docs", "title", "photo", "video", "sign"];

    _this.flattenFormFieldsForDynamicParams = function (fields, level, formType, pageLabel) {
        level = level || 0;
        formType = formType || "Formulario";
        pageLabel = pageLabel || "";
        return (fields || []).flatMap(function (field) {
            if (field.type === "group") {
                var currentField = {
                    ...field,
                    level: level,
                    name: field.name || field.label,
                    form: formType,
                    page: pageLabel,
                    section: "form",
                    filterMode: "param",
                    filterKey: "payload." + field.id + ".value"
                };
                var nodesProcessed = (field.nodes && field.nodes.length)
                    ? _this.flattenFormFieldsForDynamicParams(field.nodes, level + 1, formType, pageLabel)
                    : [];
                return [currentField].concat(nodesProcessed);
            }
            if (_this.excludedFieldTypesForDynamicParams.includes(field.type)) {
                return [];
            }
            return [{
                ...field,
                level: level,
                name: field.name || field.label,
                form: formType,
                page: pageLabel,
                section: "form",
                filterMode: "param",
                filterKey: "payload." + field.id + ".value"
            }];
        });
    };

    _this.flattenValidateFieldsForDynamicParams = function (fields, level, pageLabel, parentSimplelistId) {
        level = level || 0;
        var validatorLabel = $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.FORM_FILTER.VALIDATOR");
        return (fields || []).flatMap(function (field) {
            if (!field || !field.id) {
                return [];
            }
            var childNodes = Array.isArray(field.nodes) ? field.nodes : null;
            var filterKey = parentSimplelistId
                ? "validate.payload." + parentSimplelistId + ".value." + field.id + ".value"
                : "validate.payload." + field.id + ".value";
            var current = {
                ...field,
                id: "validate_" + field.id,
                originalId: field.id,
                level: level,
                name: field.name || field.label,
                form: validatorLabel,
                page: pageLabel,
                section: "validate",
                filterMode: "param",
                filterKey: filterKey,
                synthetic: false
            };
            if (field.type === "group") {
                var groupChildren = childNodes
                    ? _this.flattenValidateFieldsForDynamicParams(childNodes, level + 1, pageLabel, parentSimplelistId)
                    : [];
                return [current].concat(groupChildren);
            }
            if (_this.excludedFieldTypesForDynamicParams.includes(field.type)) {
                return [];
            }
            if (field.type === "simplelist") {
                var listChildren = childNodes
                    ? _this.flattenValidateFieldsForDynamicParams(childNodes, level + 1, pageLabel, field.id)
                    : [];
                return [current].concat(listChildren);
            }
            return [current];
        });
    };

    _this.formFilterLabel = function (key) {
        return $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.FORM_FILTER." + key);
    };

    _this.formFilterPageLabel = function (pageIndex) {
        return _this.formFilterLabel("PAGE") + " " + (pageIndex + 1);
    };

    _this.buildListFieldsFromForm = function (form) {
        if (!form || !form.pages) {
            return [];
        }
        var dates = [
            { id: "_createdAt", name: _this.formFilterLabel("UPLOADED"), type: "timestamp", section: "date", filterMode: "param", filterKey: "_createdAt", synthetic: true, level: 0 },
            { id: "_startedAt", name: _this.formFilterLabel("CREATED"), type: "timestamp", section: "date", filterMode: "param", filterKey: "_startedAt", synthetic: true, level: 0 },
            { id: "closedAt", name: _this.formFilterLabel("CLOSED"), type: "timestamp", section: "date", filterMode: "param", filterKey: "closedAt", synthetic: true, level: 0 },
        ];
        var formLabel = _this.formFilterLabel("FORM");
        var formFields = form.pages.flatMap(function (page, pageIndex) {
            return _this.flattenFormFieldsForDynamicParams(page.fields, 0, formLabel, _this.formFilterPageLabel(pageIndex));
        });
        if (!form.validate_required) {
            return dates.concat(formFields);
        }
        var validateFields = (form.validate_pages || []).flatMap(function (page, pageIndex) {
            return _this.flattenValidateFieldsForDynamicParams(page.fields, 0, _this.formFilterPageLabel(pageIndex), null);
        });
        return dates.concat(formFields, validateFields);
    };

    _this.getDynamicParamGroup = function (field) {
        if (!field || field.section === "date") {
            return "";
        }
        var label = field.form || "";
        if (field.page) {
            label = label ? (label + " - " + field.page) : field.page;
        }
        return label;
    };

    _this.getListFieldLabel = function (field) {
        var indent = field.level ? "\u00A0\u00A0\u00A0\u00A0".repeat(field.level) : "";
        var label = indent + (field.name || field.label || "");
        if (!field.synthetic && field.type) {
            label += " (" + field.type + " - " + field.id + ")";
        }
        return label;
    };

    _this.findFieldInListFields = function (fieldId) {
        return (_this.listfields || []).find(function (field) {
            return field.id === fieldId;
        });
    };

    _this.findFieldInForm = function (form, fieldId) {
        if (!form || !form.pages || !fieldId) {
            return null;
        }
        var found = null;
        function searchFields(fields) {
            if (!fields || found) {
                return;
            }
            fields.forEach(function (field) {
                if (found) {
                    return;
                }
                if (field.id === fieldId) {
                    found = field;
                    return;
                }
                if (field.nodes && field.nodes.length) {
                    searchFields(field.nodes);
                }
            });
        }
        form.pages.forEach(function (page) {
            searchFields(page.fields);
        });
        return found;
    };

    _this.resolveFieldForFilter = function (fieldId) {
        return _this.findFieldInListFields(fieldId) || _this.findFieldInForm(_this.form, fieldId);
    };

    _this.isNumericFieldForFilter = function (field) {
        // return field && (field.type === "number" || field.type === "autonumeric"); // Number en la base se guarda como string, autonumeric como number.
        return field && (field.type === "autonumeric");
    };

    _this.buildFilterPiece = function (field, fieldId, paramKey) {
        var filterKey = field && field.filterKey ? field.filterKey : "payload." + fieldId + ".value";
        var rawValue;
        if (field && field.filterMode === "literal") {
            rawValue = '"' + field.literalValue + '"';
        } else if (field && field.filterMode === "exists") {
            rawValue = '{"exists":' + (field.exists ? "true" : "false") + "}";
        } else if (_this.isNumericFieldForFilter(field)) {
            rawValue = paramKey;
        } else {
            rawValue = '"' + paramKey + '"';
        }
        return '"' + filterKey + '":' + rawValue;
    };

    _this.buildDynamicParamsFilter = function (dynamicParams) {
        var regex = /^\{[A-Za-z0-9_]+\}$/;
        var parts = [];

        Object.entries(dynamicParams || {}).forEach(function (entry) {
            var key = entry[0];
            var val = entry[1];
            if (regex.test(key) && val && val.fieldId) {
                var field = _this.resolveFieldForFilter(val.fieldId);
                parts.push(_this.buildFilterPiece(field, val.fieldId, key));
            }
        });

        return parts;
    };

    _this.validationDayBound = function (date, endOfDay) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return year + "-" + month + "-" + day + (endOfDay ? "T23:59:59.999Z" : "T00:00:00.000Z");
    };

    _this.buildValidationFilterPieces = function () {
        if (!_this.form || !_this.form.validate_required) {
            return [];
        }
        const conn = _this.integration.configuration.connection;
        const pieces = [];
        if (conn.validationState === "ok") {
            pieces.push('"validate_lastState":"OK"');
        } else if (conn.validationState === "reject") {
            pieces.push('"validate_lastState":"REJECT"');
        } else if (conn.validationState === "not_pending") {
            pieces.push('"validate_lastState":{"exists":true}');
        } else if (conn.validationState === "pending") {
            pieces.push('"validate_lastState":{"exists":false}');
        }

        const fromDate = conn.validationFrom instanceof Date ? conn.validationFrom : null;
        const untilDate = conn.validationUntil instanceof Date ? conn.validationUntil : null;
        if (fromDate && untilDate) {
            pieces.push(
                '"validate_lastUpdate":{"between":["' + _this.validationDayBound(fromDate, false) +
                '","' + _this.validationDayBound(untilDate, true) + '"]}'
            );
        } else if (fromDate) {
            pieces.push('"validate_lastUpdate":{"gte":"' + _this.validationDayBound(fromDate, false) + '"}');
        } else if (untilDate) {
            pieces.push('"validate_lastUpdate":{"lte":"' + _this.validationDayBound(untilDate, true) + '"}');
        }
        return pieces;
    };

    _this.encodeFormFilter = function (parts) {
        if (!parts || parts.length === 0) {
            return null;
        }
        const filterStr = "{" + parts.join(",") + "}";
        return encodeURIComponent(filterStr).replace(/%7B([A-Za-z0-9_]+)%7D/g, "{$1}");
    };

    _this.copyFormUrlFallback = (url) => {
        const textarea = document.createElement("textarea");
        textarea.value = url;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        let copied = false;
        try {
            copied = document.execCommand("copy");
        } catch (e) {
            copied = false;
        }
        document.body.removeChild(textarea);
        return copied;
    };

    _this.clearConnectionDate = (field, $event) => {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        const openedByField = {
            minDate: "minDateOpened",
            maxDate: "maxDateOpened",
            validationFrom: "validationFromOpened",
            validationUntil: "validationUntilOpened"
        };
        _this.integration.configuration.connection[field] = null;
        if (openedByField[field]) {
            $scope[openedByField[field]] = false;
        }
    };

    _this.copyFormUrl = ($event) => {
        if ($event) {
            $event.preventDefault();
        }
        const url = _this.integration.configuration.connection.url || "";
        if (!url) {
            return;
        }
        const onSuccess = () => toast.success($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.COPY_URL_OK"));
        const onError = () => toast.error($translate.instant("DASHBOARD.DASH_INTEG.FIELDS.COPY_URL_ERROR"));
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(onSuccess).catch(() => {
                if (_this.copyFormUrlFallback(url)) {
                    onSuccess();
                    return;
                }
                onError();
            });
            return;
        }
        if (_this.copyFormUrlFallback(url)) {
            onSuccess();
            return;
        }
        onError();
    };

    _this.loadFormForUrl = function (formId) {
        return Form.find({
            filter: {
                where: { id: formId },
                fields: ["id", "name", "pages", "validate_required", "validate_pages"],
            },
        }).$promise.then(function (forms) {
            if (forms && forms[0]) {
                _this.form = forms[0];
                _this.listfields = _this.buildListFieldsFromForm(_this.form);
            } else {
                _this.listfields = [];
            }
            return _this.form;
        }).catch(function (err) {
            console.error("Error al cargar formulario para URL:", err);
            return _this.form;
        });
    };

    // For Forms
    _this.updateFormUrl = () => {
        if (_this.integration.configuration.connection.urlType !== "form") {
            return;
        }

        const apiURL = require("../server").server;
        const formId = _this.integration.configuration.connection.selectedForm?.formId;

        if (!formId || formId === '') {
            return;
        }

        _this.form = _this.departmentforms.find(dept => dept.forms.some(f => f.id === formId))?.forms.find(f => f.id === formId) || _this.form;

        _this.loadFormForUrl(formId).then(function () {
            return Form.tenant({ id: formId }).$promise;
        }).then(function (tenant) {
            const accessToken = tenant.apiToken;
            const accountId = tenant.id;

            let formUrl = apiURL + '/forms/' + formId + '/getData/v2?access_token=' + accessToken + '&accountId=' + accountId;

            if (_this.integration.configuration.connection.rows) {
                formUrl += '&rows=' + _this.integration.configuration.connection.rows;
            }
            if (_this.integration.configuration.connection.minDate instanceof Date) {
                const minDateStr = _this.integration.configuration.connection.minDate
                    .toISOString()
                    .split('T')[0];
                formUrl += '&minDate=' + minDateStr;
            }
            if (_this.integration.configuration.connection.maxDate instanceof Date) {
                const maxDateStr = _this.integration.configuration.connection.maxDate
                    .toISOString()
                    .split('T')[0];
                formUrl += '&maxDate=' + maxDateStr;
            }

            const dynamicParams = _this.integration.configuration.connection.dynamicParams || {};
            const encodedFilter = _this.encodeFormFilter(
                _this.buildDynamicParamsFilter(dynamicParams).concat(_this.buildValidationFilterPieces())
            );

            if (encodedFilter) {
                formUrl += "&filter=" + encodedFilter;
            }

            _this.integration.configuration.connection.url = formUrl;
        }).catch(function (e) {
            console.error('Error al armar URL de formulario:', e);
        });
    };

    // For Forms
    _this.reloadElements = function (init = false) {
        const url = _this.integration.configuration.connection.url;

        // Si no es init
        if (!init &&_this.integration.configuration?.connection?.selectedForm?.formId != undefined) {
            let formId = _this.integration.configuration.connection.selectedForm?.formId;
            _this.integration.configuration.connection.selectedForm = _this.flattenedForms.find(function (form) {
                return form.formId == formId;
            });
            if (_this.integration.configuration.connection.selectedForm) {
                _this.updateFormUrl();
            }
            return;
        }

        // Si es init
        if (init && url && url !== '') {
            const matches = url.match(/forms\/([^\/]+)/);
            let formId = matches ? matches[1] : null;
            _this.integration.configuration.connection.selectedForm = _this.flattenedForms.find(function (form) {
                return form.formId == formId;
            });
            if (_this.integration.configuration.connection.selectedForm) {
                _this.updateFormUrl();
            }
        }
    }

    // For URL compatibility & Initialization
    if (!_this.integration.configuration.connection.hasOwnProperty('urlType') && !_this.integration.id == null) {
        _this.integration.configuration.connection.urlType = 'voolks_sheet';
        _this.selectUrlTab('voolks_sheet', true);
    } else {
        if(_this.integration.configuration.connection.urlType == null){
            _this.integration.configuration.connection.urlType = 'form';
            _this.selectUrlTab('form', true);    
        }
        if (_this.integration.configuration.connection.urlType == 's3') {
            if (_this.integration.configuration.connection.s3 && 
                _this.integration.configuration.connection.s3.columns) {
                const pkIndex = _this.integration.configuration.connection.s3.columns.findIndex(col => col.pk === true);
                _this.selectedPK = pkIndex >= 0 ? pkIndex : null;
            }
        } else {
            const url = _this.integration.configuration.connection.url;
            switch (_this.integration.configuration.connection.urlType) {
                case 'form':
                    if (url && url !== '') {
                        _this.reloadElements(true);
                    }
                    break;
                case 'google':
                    _this.selectUrlTab('google', true);
                    break;
                case 'voolks_sheet':
                    _this.selectUrlTab('voolks_sheet', true);
                    break;
                case 'standard':
                    break;
                case 'ai':
                    _this.integration.configuration.type = 'json';
                    _this.integration.configuration.typeRequest = 'json';
                    _this.integration.configuration.connection.allowOffline = false;
                    _this.integration.configuration.connection.method = 'POST';
                    _this.integration.configuration.connection.url = '{ai-voolks-multimodal}';
                    if (!_this.integration.configuration.auth) {
                        _this.integration.configuration.auth = {};
                    }
                    _this.integration.configuration.auth.type = 'AI';
                    _this.ensureAiConnectionFields(_this.integration.configuration.connection);
                    _this.integration.configuration.populateValues = _this.populateValuesForTab(
                        'ai',
                        _this.integration.configuration.populateValues
                    );
                    break;
                default:
                    break;
            }
        }
    }

    // AL INICIAR CON VOOLKS_SHEET || GOOGLE, SIMPLE NO CARGAMOS EL EDITOR HTML.
    if (!((_this.integration.configuration.connection.urlType === 'voolks_sheet' || _this.integration.configuration.connection.urlType === 'google') && _this.integration.configuration?.afterHookType === 'simple')) {
        angular.element(document).ready(_this.loadEditorHTML);
    }
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      integration: "=",
      clients: "=",
      departments: "=",
      departmentforms: '=',
    },
    controller: dashboardIntegrationDirectiveCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "dashboard-integration/dashboardIntegrationDirective.html",
  };
};
